import React from 'react'
import { useModal } from 'view/shared/modal'
import { Dropzone } from 'view/shared/upload'
import { useSelector } from 'react-redux'
import { MidTradeEventUploadDialog } from './MidTradeEventUploadDialog'
import { canUploadMidTradeEventsSelector, MID_TRADE_VIEW_HISTORICAL, MID_TRADE_VIEW_INCOMING } from 'selectors/midTradeEventsSelectors'
import { useMidTradeEventsView } from 'view/routes/midTradeEvents/Screen/MidTradeEventsViewContext'

interface MidTradeEventDropzoneProviderProps {
  children: JSX.Element
}

export const MidTradeEventDropzoneProvider: React.FC<MidTradeEventDropzoneProviderProps> = ({ children }) => {
  const canUpload = useSelector(canUploadMidTradeEventsSelector)
  const { showModal } = useModal()
  const view = useMidTradeEventsView() ?? ''

  if (!canUpload || view === MID_TRADE_VIEW_HISTORICAL) {
    return children
  }

  const dropFilesHandler = (incoming?: boolean) => (files: File[]) => {
    showModal(<MidTradeEventUploadDialog initialFile={files[0]} incoming={incoming} />)
  }

  const pasteHandler = (incoming?: boolean) => (clipboard: string) => {
    showModal(<MidTradeEventUploadDialog initialClipboard={clipboard} incoming={incoming} />)
  }

  const isIncoming = view === MID_TRADE_VIEW_INCOMING

  return <Dropzone render={() => <>{children}</>} onDropFiles={dropFilesHandler(isIncoming)} onPaste={pasteHandler(isIncoming)} />
}
